<template>
    <div class="page resetPass">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="restTypeSection">
                        <h2 class="text-center ktdarkchoc mediaHideOnDesctop">Not to worry, let’s find you!</h2>
                        <div class="descktopMediaBox">
                            <div class="h1">
                                Forgot your password?
                            </div>
                        </div>
                        <div class="restType ktdarkchoc">
                            <div @click="$router.push({name: 'AccountLookup', params: {type: 'email'}})">
                                Use your email...
                                <img :src="getStaticImage('icons/arrow_red.png')" alt="">
                            </div>
                            <div @click="$router.push({name: 'AccountLookup', params: {type: 'phone'}})">
                                Use your phone number...
                                <img :src="getStaticImage('icons/arrow_red.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResetPassword",
        created() {
            this.$store.commit("shared/setTopBar", {title: "Reset Password", showBackButton: true});
        },
    }
</script>
